"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var models_1 = require("../models");
var API = /** @class */ (function () {
    function API(authHeaderKey, headerValue) {
        var _a;
        var clientConfig = {
            headers: (_a = {},
                _a[authHeaderKey] = headerValue,
                _a),
            baseURL: models_1.Model.getBaseUrl(),
        };
        this.client = axios_1.default.create(clientConfig);
    }
    return API;
}());
exports.API = API;
